var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M200,400 C89.54305,400 0,310.45695 0,200 C0,89.54305 89.54305,0 200,0 C310.45695,0 400,89.54305 400,200 C400,310.45695 310.45695,400 200,400 Z M285.575758,157.090909 C289.454545,153.212121 289.454545,147.393939 285.575758,143.515152 C281.69697,139.636364 275.878788,139.636364 272,143.515152 L172.121212,243.393939 L130.424242,201.69697 C126.545455,197.818182 120.727273,197.818182 116.848485,201.69697 C112.969697,205.575758 112.969697,211.393939 116.848485,215.272727 L165.333333,263.757576 C167.272727,265.69697 169.212121,266.666667 172.121212,266.666667 C175.030303,266.666667 176.969697,265.69697 178.909091,263.757576 L285.575758,157.090909 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.27710f2a89eeb963583c9f27fa823f18.svg";
export { ForwardRef as ReactComponent };